<template>
  <div class="card toggle-card">
    <div class="card-header text-secondary" @click="isShowing = !isShowing">
      {{ title }}
      <font-awesome-icon class="float-right m-1" :icon="toggleIcon" />
    </div>
    <hr />
    <div class="card-body" v-show="isShowing">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToggleCard",
  props: {
    title: String,
    showInitially: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowing: false
    };
  },
  created() {
    this.isShowing = this.showInitially;
  },
  computed: {
    toggleIcon() {
      return this.isShowing ? "angle-down" : "angle-up";
    }
  }
};
</script>
